import { render, staticRenderFns } from "./Polymers.vue?vue&type=template&id=04ef1508&"
import script from "./Polymers.vue?vue&type=script&lang=js&"
export * from "./Polymers.vue?vue&type=script&lang=js&"
import style0 from "./Polymers.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports